<template>
  <PageTitle />
  <SelectedVehiclePanel :isChoose="true" :noSelectedMsg="'Choose vehicle below'" v-if="isShowSelectedVehicle"/>
  <RentalVehiclePanel />
  <SearchPanel v-if="isShowSearchVehicle"/>
</template>

<script>

import PageTitle from "@/components/Common/PageTitle.vue";
import SelectedVehiclePanel from "@/components/Vehicle/Selected.vue";
import SearchPanel from "@/components/Vehicle/Search.vue";
import RentalVehiclePanel from "@/components/Vehicle/RentalVehicle.vue";

export default {
  name: 'SelectVehicleView',
  components: {
    RentalVehiclePanel,
    SearchPanel,
    SelectedVehiclePanel,
    PageTitle,
    //
  },
  data() {
    return {
      isShowSelectedVehicle: true,
      isShowRentalVehicle: true,
      isShowSearchVehicle: true,
    }
  },
  mounted() {
    // Set selected vehicle
    // this.$store.dispatch('vehicle/selected')

    // Set a details based on selected vehicle
    // this.$store.dispatch('vehicle/details')

    // Set page title
    this.$store.dispatch('setPageTittle', 'Select Vehicle', '/dashboard')
  }
}
</script>